import type { TPassportUnitCodeSuggestItem, TPassportUnitCodeSuggests } from 'shared/types';

const mapUnitCodes = ({ name, code }: TPassportUnitCodeSuggestItem) => ({
  value: `${name} ${code}`,
  label: code || '',
  data: { name, code },
});

export const mapUnitCodesToSelectOptions = (
  response?: TPassportUnitCodeSuggests,
): Array<Dictionaries.TSelectOption<string, TPassportUnitCodeSuggestItem>> =>
  (response?.results || []).map(mapUnitCodes);
